import { Injectable, inject } from '@angular/core';

import { ClientConfigDBService } from '../db/client-config-db-service';
import { Resolve } from '@angular/router';
import { PointConfig } from '@core/api';

@Injectable()
export class PointConfigResolver implements Resolve<PointConfig> {
  private clientConfigDbService = inject(ClientConfigDBService);

  public resolve() {
    return this.clientConfigDbService.getPointConfig();
  }
}
